import {ChangeDetectionStrategy, Component, HostListener, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {UserSearch} from '@models/search';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AlertService} from '@services/alert.service';
import {DialogPosition, MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import * as $ from 'jquery';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {SaveComponent} from '@module/search/popup/save/save.component';
import {AlertComponent} from '@module/search/popup/alert/alert.component';
import {OnboardingService} from '@services/onboarding.service';
import {PubSaveComponent} from '@module/search/popup/pub-save/pub-save.component';
import {PubOpenComponent} from '@module/search/popup/pub-open/pub-open.component';
import {environment} from '~/environments/environment';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {EMPTY_FAVORITE_LIST, EVOL_DEMO_LAST_YEAR} from '@models/empty';
import * as _ from 'underscore';
import {Title} from '@angular/platform-browser';
import {PreviewPopupComponent} from '@module/search/results/preview-popup/preview-popup.component';
import {EditComponent} from '@module/search/popup/edit/edit.component';
import {DuplicateComponent} from '@module/search/popup/duplicate/duplicate.component';
import {AlertConfirmComponent} from '@module/search/popup/alert-confirm/alert-confirm.component';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {AlertHsComponent} from '@module/search/popup/alert-hs/alert-hs.component';
import {ToomanyFavComponent} from '@components/popup/toomany-fav/toomany-fav.component';
import {AddComponent} from '@module/favorites/popup/add/add.component';
import {BugComponent} from '@module/annonces/popup/bug/bug.component';
import {NotesComponent} from '@module/favorites/popup/notes/notes.component';
import {TutoComponent} from '@components/popup/tuto/tuto.component';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-results',
    templateUrl: './results.component.html',
    styleUrls: ['./results.component.scss'],
})
export class ResultsComponent implements OnInit {
    favorites: Favorite[] = [];
    cacheFavorites: Favorite[] = [];
    loading = true;
    nb_result = -1;

    params;
    sort = 'first_publication-desc';
    idSearch = '';
    onboarding = false;
    url = '';

    currentSearch: UserSearch;
    userSearchs: UserSearch[] = [];

    stripe = Stripe(environment.stripeKey);
    columsSelection = false;
    displayedColumns: string[] = [];
    max_display = 20;

    loginForm = null;

    page = 1;
    pages = [];

    sub_search = null;

    constructor(
        private adService: AdService,
        private userService: UserService,
        private alertService: AlertService,
        private onboardingService: OnboardingService,
        private dialog: MatDialog,
        private location: Location,
        private http: HttpClient,
        private route: ActivatedRoute,
        public router: Router,
        private deviceService: DeviceDetectorService,
        private titleService: Title,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
        this.router.events.subscribe((val) => {
            if (this.loginForm !== null) {
                clearTimeout(this.loginForm);
                this.loginForm = null;
            }
        });

        this.params = {'id': ''};
        if (this.authenticationService.isLogin) {
            this.adService.getUserSearch().subscribe(r => {
                if (this.authenticationService.isAllowed('essentiel')) {
                    this.userSearchs = r;
                }
                this.setParams();
            });
            if (this.authenticationService.currentUser.user_dashboard.search_kpi === undefined || this.authenticationService.currentUser.user_dashboard.search_kpi === null || this.authenticationService.currentUser.user_dashboard.search_kpi.length == 0 || !this.authenticationService.isAllowed('expert')) {
                this.displayedColumns = ['ad_city.price_diff', 'ad_city.demographie_annuelle', 'ad_city.carac_commune.mv', 'favorite.ad_city.renta', 'ad_city.carac_commune.te', 'ad_city.advice_price', 'amount_rent', 'ad_city.carac_commune.tc'];
            } else {
                this.displayedColumns = this.authenticationService.currentUser.user_dashboard.search_kpi;
            }
        } else {
            this.trackingService.click('search_result_open_login', '');
            this.displayedColumns = ['ad_city.price_diff', 'ad_city.demographie_annuelle', 'ad_city.carac_commune.mv', 'favorite.ad_city.renta', 'ad_city.carac_commune.te', 'ad_city.advice_price', 'amount_rent', 'ad_city.carac_commune.tc'];
            this.loginForm = setTimeout(() => {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    disableClose: true,
                    data: {
                        disableClose: true
                    },
                });
            }, 10000);
            this.setParams();
        }

        this.onboardingService.listen().subscribe(elem => {
            if (elem == 'search_start') {
                this.onboarding = true;
                if (this.favorites.length > 3) {
                    this.cacheFavorites = this.favorites;
                    this.favorites = [this.favorites[0], this.favorites[1]];
                }
            }
            if (elem == 'search_end') {
                this.favorites = this.cacheFavorites;
                this.onboarding = false;
            }
        });
        if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.search.status == 'done' && this.authenticationService.currentUser.user_onboarding.search_save.status == 'not_started') {
            this.onboardingService.startSearchSave().subscribe();
        }

        if (this.deviceService.isMobile()) {
            this.max_display = 6
        }
    }

    setParams() {
        this.route.queryParams.subscribe(params => {
            if (params.page) {
                this.page = parseInt(params.page);
            } else {
                this.page = 1;
            }
            this.url = this.router.url;

            this.route.params.subscribe(params => {
                this.params = params;
                if (params.id !== undefined) {
                    this.idSearch = params.id;
                    if (this.idSearch == 'result') {
                        this.userService.getCurrentSearch().subscribe(params => {
                            this.currentSearch = params;
                            this.search(null);
                        });
                    } else {
                        this.setSearch();
                        if (this.authenticationService.currentUser.user_onboarding.auto
                            && this.authenticationService.currentUser.user_onboarding.search.status != 'not_started'
                            && this.authenticationService.currentUser.user_onboarding.search_save.status != 'not_started'
                            && this.authenticationService.currentUser.user_onboarding.alert.status == 'not_started'
                        ) {
                            this.onboardingService.startAlert(this.idSearch).subscribe();
                        }
                    }
                }
            });
        });
    }

    setSearch() {
        if (this.idSearch !== undefined) {
            if (this.authenticationService.isAllowed('essentiel')) {
                this.userSearchs.forEach(f => {
                    if (f.id === parseInt(this.idSearch, 10)) {
                        this.currentSearch = f;
                        this.search(null);
                    }
                });
                if (this.currentSearch == null) {
                    this.router.navigate(['/app/search/result']);
                    this.userService.getCurrentSearch().subscribe(params => {
                        this.currentSearch = params;
                        this.search(null);
                    });
                } else {
                    this.verifyAlert();
                }
            } else {
                this.alertService.error('Cette fonctionnalité néccessite un plan supérieur, consultez nos forfaits dans Mon comptes > Nos forfaits');
                this.router.navigate(['/app/search/result']);
            }
        }
    }

    upgradePlan(visuel = '', feature, plan) {
        this.trackingService.click('search_result_upgrade_plan', feature);
        if (!this.authenticationService.isLogin) {
            const dialogRef = this.dialog.open(LoginFormComponent, {
                width: '550px',
                data: {
                    disableClose: false
                },
            });
        } else {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel, plan, feature}
            });
        }
    }

    verifyAlert() {
        if (this.currentSearch.frequency_alert != '0' && this.currentSearch.frequency_alert != '1' && !this.authenticationService.isAllowed('expert')) {
            this.trackingService.click('search_result_search_alert_hs_open', this.currentSearch.id);
            const dialogRef = this.dialog.open(AlertHsComponent, {
                width: '480px',
                data: {userSearch: this.currentSearch},
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.trackingService.click('search_result_search_alert_hs_confirm', this.currentSearch.id);
                    this.saveAlerte();
                } else {
                    this.trackingService.click('search_result_search_alert_hs_cancel', this.currentSearch.id);
                }
            });
        }
    }

    setSort() {
        this.currentSearch.search_ad_params.sort = this.sort.split('-')[0];
        this.currentSearch.search_ad_params.sort_order = this.sort.split('-')[1];
        if (this.idSearch != 'result') {
            this.adService.editUserSearch(this.currentSearch).subscribe((us) => {
                this.router.navigate(['/app/search', this.params.id]);
            });
        } else {
            this.userService.setCurrentSearch(this.currentSearch).subscribe((us) => {
                this.router.navigate(['/app/search/result'])
            });
        }

        this.search(1)
    }
    search(page) {
        if (page !== null) {
            this.page = page;
        }

        if (this.page > 1 && !this.authenticationService.isAllowed('essentiel')) {
            this.upgradePlan('assets/upgrade/search.png', 'Moteur de recherche', 'Essentiel');
            return
        }

        var show = false;
        if (this.userSearchs.length == 0) {
            if (this.authenticationService.currentUser.user_onboarding.popup_search_save == ''
                || this.authenticationService.currentUser.user_onboarding.popup_search_save == undefined) {
                show = true;
            } else {
                var date = new Date();
                var last = new Date(this.authenticationService.currentUser.user_onboarding.popup_search_save);
                if (date.getTime() - last.getTime() > (1000 * 60 * 60) * 6) { // Toute les 6 heures
                    show = true;
                }
            }
        }

        if (this.idSearch == 'result' && this.page > 2 && show == true && this.authenticationService.isLogin) {
            this.authenticationService.currentUser.user_onboarding.popup_search_save = new Date().toString();
            this.userService.updateOnboarding(this.authenticationService.currentUser);
            this.trackingService.click('search_result_search_save_pub_open', this.currentSearch.id);

            const dialogRef = this.dialog.open(PubSaveComponent, {
                width: '420px',
                data: {searchParams: this.currentSearch.search_ad_params, userSearchs: this.userSearchs},
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.trackingService.click('search_result_search_save_pub_confirm', this.currentSearch.id);
                    this.userSearchs = result.userSearchs;
                    this.userSearchs.forEach(s => {
                        if (s.id === result.currentSearch.id) {
                            this.currentSearch = s;
                            this.idSearch = '' + this.currentSearch.id;
                            this.location.replaceState('/app/search/' + this.currentSearch.id);
                            this.alertService.success("Enregistrement réussi.");
                        }
                    });
                } else {
                    this.trackingService.click('search_result_search_save_pub_cancel', this.currentSearch.id);
                }
            });
        }

        let page_first = 0;
        let page_last = 0;

        if (this.deviceService.isMobile()) {
            if (this.page > 3) {
                page_first = this.page - 3;
                page_last = this.page + 3;
            } else {
                page_first = 1;
                page_last = 6;
            }
        } else {
            if (this.page > 6) {
                page_first = this.page - 5;
                page_last = this.page + 5;
            } else {
                page_first = 1;
                page_last = 10;
            }
        }


        this.loading = true;
        this.favorites = [];
        this.trackingService.search({page: this.page});

        if (this.currentSearch.title) {
            this.titleService.setTitle('LyBox - ' + 'Recherche ' + this.currentSearch.title + (this.page > 1 ? ' - Page ' + this.page : ''));
        } else {
            this.titleService.setTitle('LyBox - ' + 'Moteur de recherche' + (this.page > 1 ? ' - Page ' + this.page : ''));
        }
        this.currentSearch.search_ad_params.last = (this.page - 1) * 10;
        this.sort = this.currentSearch.search_ad_params.sort + '-' + this.currentSearch.search_ad_params.sort_order;
        if (this.sort == '-') {
            this.sort = 'first_publication-desc';
        }

        if (this.sub_search) {
            this.sub_search.unsubscribe();
        }

        this.sub_search = this.adService.search(this.currentSearch.search_ad_params).subscribe(res => {

            const favorites = res.favorites;
            this.nb_result = res.result;
            if (page_last * 10 > this.nb_result) {
                page_last = Math.ceil(this.nb_result / 10);
            }

            this.pages = [];
            for (let i = page_first; i <= page_last; i++) {
                this.pages.push(i);
            }

            favorites.forEach((favorite, i) => {
                favorite.notary_price = null; // To calc them
                favorite = this.adService.fillUSerInfo(favorite);
                this.favorites.push(this.adService.fillDisplayData(favorite, i));
            });

            this.loading = false;
            if (this.onboarding === true) {
                this.cacheFavorites = this.favorites;
                this.favorites = [this.favorites[0], this.favorites[1]];
            }

        }, error => {
            this.loading = false;
            if (error === 'Too Many Requests') {
                this.alertService.error('Trop de requètes, réessayer dans quelques minutes.');
            } else {
                this.alertService.error('Une erreur est survenue');
            }
            console.log(error);
        });
    }

    changeImg(event, i, id) {
        if (i === 0) {
            event.target.src = 'assets/vendu.png';
            $('.card-' + id).addClass('sell');
        }
    }

    deleteFav(favorite) {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '480px',
            data: {message: 'Etes-vous sûr de vouloir supprimer ce favoris et perdre toute les informations saisies ?'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.trackingService.deleteFavorite();
                this.adService.deleteFavorite(favorite).subscribe(r => {
                    favorite.id = '';
                    favorite.favorite_list = EMPTY_FAVORITE_LIST;
                });
            }
        });
    }

    saveFav(favorite) {
        if (favorite.id !== '' && favorite.favorite_list.id !== '') {
            setTimeout(() => {
                window.open('/app/favorites/' + favorite.favorite_list.id + '/' + favorite.id, '_blank');
            });
        } else if (favorite.loading === false || favorite.loading === undefined) {
            favorite.loading = true;
            this.trackingService.addFavorite();

            if (this.authenticationService.isLogin) {
                if (!this.authenticationService.isAllowed('basique')) {
                    const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                        width: '520px',
                        data: {visuel: 'assets/upgrade/simulation.png', plan: 'Basique', feature: 'Simulateur d\'investissement', disableClose: true},
                    });
                } else {
                    // authorised so return true
                    const dialogRef = this.dialog.open(AddComponent, {
                        width: '480px',
                        data: {favorite: favorite, mode: 'create'},
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        favorite.loading = false;
                        if (result !== false && result !== undefined) {
                            if (result == 'toomany') {
                                this.trackingService.click('upgrade_plan_favorite_open', this.authenticationService.currentUser.plan);
                                const dialogRef = this.dialog.open(ToomanyFavComponent, {
                                    width: '420px',
                                    data: {
                                        plan: this.authenticationService.currentUser.plan,
                                    },
                                });
                            } else {
                                favorite.id = result[1].id;
                                favorite.favorite_list = result[1].favorite_list;
                            }
                        }
                    });
                }
            } else {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    disableClose: true,
                    data: {
                        disableClose: true
                    },
                });
            }
        }
    }

    hideFav(favorite) {
        favorite.hide = !favorite.hide;
        this.adService.hideFav(favorite);
    }

    addBug(favorite) {
        const dialogRef = this.dialog.open(BugComponent, {
            width: '480px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {favorite: favorite},
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result == true) {
                this.trackingService.click('search_result_bug_send', favorite.ad.ai_id);
            } else {
                this.trackingService.click('search_result_bug_close', favorite.ad.ai_id);
            }
        });
    }

    openLybox(favorite, index) {
        if (favorite.loading == true) {
            return;
        }

        if (this.authenticationService.isLogin) {
            this.trackingService.click('search_result_open_ad_plan_open', this.currentSearch.id);
            const dialogRef = this.dialog.open(PubOpenComponent, {
                width: '700px',
                data: {
                    close: true,
                },
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== null && result !== undefined && result !== '') {
                    this.trackingService.click('search_result_open_ad_plan_confirm', this.currentSearch.id);
                    this.loading = true;
                    this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
                        {plan: result, duration: 'month'}).subscribe(
                        session => {
                            this.trackingService.checkout({value: result});
                            this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                                if (result.error) {
                                    alert(result.error.message);
                                }
                            });
                        },
                        (error) => {
                            console.log(error);
                            this.loading = false;
                            this.alertService.error('Erreur');
                        });
                } else {
                    this.trackingService.click('search_result_open_ad_plan_cancel', this.currentSearch.id);
                }
            });
            return;
        } else {
            this.router.navigate(['/app/login'], {queryParams: {returnUrl: this.router.url}});
        }
    }

    editSearch() {
        const dialogRef = this.dialog.open(EditComponent, {
            width: '420px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {userSearch: this.currentSearch},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success('Enregistrement réussi.');
                this.trackingService.click('search_result_search_rename_confirm', this.currentSearch.id);
                this.userSearchs.forEach(s => {
                    if (s.id === result.currentSearch.id) {
                        this.currentSearch = s;
                    }
                });
            } else {
                this.trackingService.click('search_result_search_rename_cancel', this.currentSearch.id);
            }
        });
    }

    duplicateSearch() {
        const dialogRef = this.dialog.open(DuplicateComponent, {
            width: '420px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {userSearch: this.currentSearch},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success('Enregistrement réussi.');
                this.trackingService.click('search_result_search_duplicate_confirm', this.currentSearch.id);
                this.userSearchs.push(result.currentSearch);
                this.userSearchs.forEach(s => {
                    if (s.id === result.currentSearch.id) {
                        this.currentSearch = s;
                        this.idSearch = '' + this.currentSearch.id;
                        this.location.replaceState('/app/search/' + this.currentSearch.id);
                        this.url = '/app/search/' + this.currentSearch.id;
                    }
                });
            } else {
                this.trackingService.click('search_result_search_duplicate_cancel', this.currentSearch.id);
            }
        });
    }

    deleteSearch() {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '420px',
            data: {message: 'Etes-vous sûr de vouloir supprimer la recherche "' + this.currentSearch.title + '"'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.trackingService.click('search_result_search_delete_confirm', this.currentSearch.id);
                this.adService.deleteSearch(this.currentSearch).subscribe(r => {
                    this.userSearchs.forEach((s, i) => {
                        if (s.id === this.currentSearch.id) {
                            this.userSearchs.splice(i, 1);
                        }
                    });
                    this.router.navigate(['/app/search/result']);
                    this.alertService.success('Recherche supprimée.', true);
                }, error => {
                    this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                });
            } else {
                this.trackingService.click('search_result_search_delete_cancel', this.currentSearch.id);
            }
        });
    }

    saveSearch() {
        if (!this.authenticationService.isAllowed('essentiel')) {
            this.upgradePlan('assets/upgrade/search.png', 'Moteur de recherche', 'Essentiel');
        } else {
            const dialogRef = this.dialog.open(SaveComponent, {
                width: '420px',
                position: {top: (this.deviceService.isMobile() ? '55px' : '')},
                data: {searchParams: this.currentSearch.search_ad_params, userSearch: this.currentSearch},
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.trackingService.click('search_result_search_save_confirm', this.currentSearch.id);
                    this.userSearchs.push(result.currentSearch);
                    this.userSearchs.forEach(s => {
                        if (s.id === result.currentSearch.id) {
                            this.currentSearch = s;
                            this.idSearch = '' + this.currentSearch.id;
                            this.location.replaceState('/app/search/' + this.currentSearch.id);
                            this.url = '/app/search/' + this.currentSearch.id;
                            this.dialog.open(AlertConfirmComponent, {
                                width: '420px',
                                data: {mode: 'recherche'},
                            });
                        }
                    });
                } else {
                    this.trackingService.click('search_result_search_save_cancel', this.currentSearch.id);
                }
            });
        }
    }

    saveAlerte() {
        if (this.idSearch == 'result') {
            return;
        }
        if (!this.authenticationService.isAllowed('essentiel')) {
            this.upgradePlan('assets/upgrade/alert.png', 'Alertes E-mails', 'Essentiel');
        } else {
            let popup = false;
            if (this.currentSearch.frequency_alert == '0') {
                popup = true;
            }
            const dialogRef = this.dialog.open(AlertComponent, {
                width: '520px',
                data: {userSearch: this.currentSearch},
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.alertService.success('Enregistrement réussi.');
                    this.trackingService.click('search_result_search_alert_confirm', this.currentSearch.id);
                    if (popup == true && result.currentSearch.frequency_alert != '0') {
                        this.dialog.open(AlertConfirmComponent, {
                            width: '420px',
                            data: {mode: 'alerte'},
                        });
                    }
                } else {
                    this.trackingService.click('search_result_search_alert_cancel', this.currentSearch.id);
                }
            });
        }
    }

    loadSearch(event) {
        this.router.navigate(['/app/search/', this.currentSearch.id]);
        this.url = '/app/search/' + this.currentSearch.id;
    }

    displayColumsSelection() {
        this.columsSelection = !this.columsSelection;
    }

    onColChange(val) {
        if (!this.authenticationService.isAllowed('expert')) {
            this.upgradePlan('assets/upgrade/indicateurs.png', 'Personnalisation des favoris', 'Expert');
        } else {
            this.trackingService.click('search_result_indicateur_change', this.currentSearch.id ? this.currentSearch.id : 'result');
            if (_.difference(val, this.displayedColumns).length !== 0) {
                // Checked
                this.displayedColumns.push(_.difference(val, this.displayedColumns)[0]);
            } else if (_.difference(this.displayedColumns, val).length !== 0) {
                // Unchecked
                this.displayedColumns = _.without(this.displayedColumns, _.difference(this.displayedColumns, val)[0]);
            }
            this.authenticationService.currentUser.user_dashboard.search_kpi = this.displayedColumns;
            this.userService.updateDashboard(this.authenticationService.currentUser);
        }
    }

    previewAd(favorite, index) {
        const dialogRef = this.dialog.open(PreviewPopupComponent, {
            width: '1060px',
            height: '610px',
            data: {favorite: favorite, url: this.url},
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result == true) {
                this.trackingService.click('search_result_preview_add_fav', favorite.ad.ai_id);
            } else {
                this.trackingService.click('search_result_preview_close', favorite.ad.ai_id);
            }
        });
    }

    noteFavorite(favorite): void {
        const dialogRef = this.dialog.open(NotesComponent, {
            width: '420px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {favorite: favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                favorite.comment = result.comment;
            }
        });
    }

    isNew(favorite) {
        let startDate = new Date(favorite.ad.fpb).getTime();
        if (new Date().getTime() - startDate < 86400000) {
            return true;
        }
        return false;
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            data: {video: 'search'}
        });
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
